import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

export type MapperArtifactTraceStage = 'source' | 'rule' | 'mapped' | 'posted' | 'result' | 'writeback';
export type MapperArtifactTraceTone = 'direct' | 'derived' | 'writeback' | 'muted';

export interface MapperArtifactTraceRow {
	stage: MapperArtifactTraceStage;
	path: string;
	label: string;
	value: string;
	traceId: string | null;
	traceLabel: string;
	description: string;
	tone: MapperArtifactTraceTone;
}

export interface MapperArtifactTracePanel {
	stage: MapperArtifactTraceStage;
	title: string;
	subtitle: string;
	emptyText: string;
	rows: MapperArtifactTraceRow[];
	mappedRows: MapperArtifactTraceRow[];
}

export interface MapperArtifactTraceItem {
	key: string;
	sourceId: string;
	summary: string;
	actionLabel: string;
	statusLabel: string;
	statusTone: 'success' | 'danger' | 'warning' | 'muted' | 'info';
	errorMessage: string;
	panels: MapperArtifactTracePanel[];
}

@Component({
	selector: 'app-mapper-artifact-trace',
	standalone: true,
	imports: [CommonModule],
	templateUrl: './mapper-artifact-trace.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	styles: [':host { display: block; }'],
})
export class MapperArtifactTraceComponent {
	@Input() items: MapperArtifactTraceItem[] = [];
	@Input() showUnmappedFields = true;
	@Output() toggleUnmappedFields = new EventEmitter<void>();

	activeArtifactTraceId = '';

	readonly trackItem = (_index: number, item: MapperArtifactTraceItem): string => item.key;
	readonly trackPanel = (_index: number, panel: MapperArtifactTracePanel): string => panel.stage;
	readonly trackRow = (_index: number, row: MapperArtifactTraceRow): string => `${row.stage}:${row.path}:${row.traceId ?? ''}`;

	setActiveArtifactTrace(traceId: string | null | undefined): void {
		this.activeArtifactTraceId = traceId ?? '';
	}
}
